define([
	"jquery",
	"pubsub",
	"wcs.utils",
	"shared.main.plugins",
	'shared.main.screen',
	"shared.lazyload",
	"foundation.reveal"
], function( $, pubsub, Utils, pluginLoader, screenSize){

var sizeChartSlideView = function(modal) {
    var self = {};

    var parent = (typeof modal === 'object') ? modal : 'body';

    self.bindEvents = function(){
        self.unbindEvents();
        $(parent).on('click.openSizeChart', '.find-size-btn-js', self.openSizeChart);
        $(parent).on('click.closeSizeChart touchend', '.size-chart-js .close-button', self.closeSizeChart);
        $.pubsub('subscribe', 'product-form.attr.swatch.click', self.updateSizeChartHref);
    };

    self.updateSizeChartHref = function(msg, object) {
        var sizeGuideUrlAttribute = $(object.target).data('productSizeGuideUrl');
        if(sizeGuideUrlAttribute) {
            $('.size-chart-link').attr('href', sizeGuideUrlAttribute);
        }
    };

    self.unbindEvents = function(){
        $(parent).off('click.openSizeChart');
        $(parent).off('click.closeSizeChart');
    };

    self.openSizeChart = function(e){
        var sizeChart = $('.size-chart-js');
        var fixedHeaderHeight = $('.topnav header.sticky').height() || 0;
        $('.lazyload', sizeChart).lazyload();
        sizeChart.slideDown(200, function(){
            //anchor to id of size chart element
            window.location.href = "#size-chart";
        });
    };

    self.closeSizeChart = function(e){
        // Used to override the default Foundation 6 close-button functionality
        e.preventDefault();
        e.stopPropagation();
        $('.size-chart-js').slideUp();
        $('html, body').animate({
            scrollTop: $(parent).offset().top
        }, 500);
    };

    self.init = function(){
        self.sizeChartElement = $('.size-chart');
        self.scrollWrapper = $('html, body');

        // Check to see if the sliding size chart is being used in a quickview modal
        if (self.sizeChartElement.parents('.quickview-box').length) {
            self.scrollWrapper = $('.reveal-overlay');
        }

        self.bindEvents();
    };

    self.init();
};

var pdpTime = ( function(){

    var self = {};

    self.updateTime = function($sel, value){
         if (value < 10){
            $sel.text('0' + value);
        }
        else{
            $sel.text(value);
        }
    };

    self.initCountDown = function(){
        var day = 24 * 60 * 60,
            hour = 60 * 60,
            minute = 60,
            $counter = $('.countdown-js'),
            $countDay = $counter.find('.countdown-day-js'),
            $countHour = $counter.find('.countdown-hours-js'),
            $countMinute = $counter.find('.countdown-min-js'),
            $countSecond = $counter.find('.countdown-sec-js'),
            timeStamp = parseInt ($countDay.text()) * day +
                        parseInt ($countHour.text()) * hour +
                        parseInt ($countMinute.text()) * minute +
                        parseInt ($countSecond.text());
        timeStamp = (new Date().getTime()) + (timeStamp * 1000);
        setInterval(function (){
            var updatedDay = 0,
            updatedHour = 0,
            updatedMin = 0,
            updatedSec = 0,
            timeLeft = 0;

            timeLeft = Math.floor((timeStamp - (new Date())) / 1000);

            if (timeLeft < 0){
                timeLeft = 0;
            }
            updatedDay = Math.floor(timeLeft / day);
            self.updateTime ($countDay, updatedDay);
            timeLeft -= updatedDay * day;

            updatedHour = Math.floor(timeLeft / hour);
            self.updateTime ($countHour, updatedHour);
            timeLeft -= updatedHour * hour;

            updatedMin = Math.floor(timeLeft / minute);
            self.updateTime ($countMinute, updatedMin);
            timeLeft -= updatedMin * minute;

            timeLeft = timeLeft - 1;
            self.updateTime ($countSecond, timeLeft < 0 ? 59 : timeLeft);
        }, 1000);
    };

    return self;

}());


var pdpUpdatePage = ( function(){

    var self = {};

    self.setSwatchPage = function(){
        isSwatchPage = $('body').hasClass('pdp-swatches');
        return isSwatchPage;
    };

    self.updateProductURL = function(productURL){
        $("a.more-detail-js").attr('href', productURL);
    };

    self.updateOGImageSrc = function ( imageURL ) {
        $("meta[ property = 'og:image']").attr( 'content', imageURL );
    };

	self.updateProductDesc = function(productDesc){
		if (productDesc !== '') {
			var parsedDesc = viewDomAdd.decodeHTML(productDesc);
	        $(".product-details-js .desc-container-js").html(parsedDesc);
		}
	};

    self.updateProductName = function(productName, productURL){
        var insertHTML;
        if( $('#isQuickView').length > 0){
            insertHTML = '<a href="'+productURL+'">'+productName+'</a>';
        }else{
            insertHTML = productName;
        }
        $("#product-info h1").html(insertHTML);
    };

	self.updateProductPartNumber = function(productPartNumber) {
		$('.product-style-js').html(productPartNumber);
	};

    self.updateProductBadge = function(productBadgeSrc, productBadgeType, $productBadge) {
        $productBadge = $productBadge || $('.product-views-promo-badge-image');

        if ($productBadge.length < 1) {
            return false;
        }

        if (productBadgeSrc && productBadgeSrc !== '' && productBadgeType && productBadgeType !== '') {
            $productBadge.attr({
                src: productBadgeSrc,
                alt: productBadgeType
            });
        } else {
            $productBadge.attr({
                src: '',
                alt: ''
            });
        }

        return true;
    };

    self.updateProductDetailDrawerDescriptionImage = function(imagePath, $productDetailDrawerDescriptionImage) {
        if (!$productDetailDrawerDescriptionImage || $productDetailDrawerDescriptionImage.length === 0) {
            $productDetailDrawerDescriptionImage = $('.product-details-drawer-container .drawer-description-image');
        }

        $productDetailDrawerDescriptionImage.attr('src', imagePath);
    };

	self.toggleSelectedClass = function($container, addSelected){
		if (addSelected) {
            $container.addClass('selected');
        }
        else {
            $container.removeClass('selected');
        }
    };

    self.toggleVisibility = function($element, visible){
        if( visible && $element.hasClass('hidden') ){
            $element.removeClass('hidden');
        }else if(!visible && !$element.hasClass('hidden') ){
            $element.addClass('hidden');
        }

    };

    self.updateProductPrice = function(productPrice){
        if(productPrice.length > 0){
            if( $('.price-container-js').length > 0)
                $('.price-container-js')[0].innerHTML = productPrice[0].innerHTML;
        }
    };


    self.populateProductPartNumberAndAttrName = function(formIndex){

        var partNumber = $('.attr-color:visible .collapsable-container-js .selected img').attr('data-part-number'),
            $productForm = $('.product-form-js').eq(formIndex);

        if( $productForm.find('.product-style-js').length > 0 ){

        }
        if( $productForm.find('.attr-selected-color-js').length > 0 ){
            $productForm.find('.attr-selected-color-js').html($productForm.find('.attr-color .collapsable-container-js .selected img').attr('alt'));
        }
    };

    self.setShowOverviewHandler = function() {
        $('.link-more-btn-js').on({
            click: function (event){
                event.preventDefault();
                $('.prod-desc-js').toggleClass ('ellip-line', 500);
            }
        });
    };

    self.initDiscountTooltips = function() {
        var tooltipSel = '.discount-container .tooltip-js',
        options = {
            contentAsHTML: true,
            multiple: true,
            animation: 'fade',
            trigger: 'click',
            interactive: true
        };

        pluginLoader.loadPlugins({
            name: 'jquery.tooltipster',
            selector: '.discount-container .tooltip-js',
            callback: function() {
                $(tooltipSel).each(function() {
                    var $this = $(this);
                    $this.tooltipster(options);
                });

                $.pubsub('subscribe', 'WCS.PRODUCT_FORM.PROMO.RENDER.COMPLETE', function(){
                    $(tooltipSel).each(function() {
                        var $this = $(this);
                        $this.tooltipster(options);
                    });
                });
            }
        });
    };

    self.setStepContentWidths = function(){
        var containerWidth = $('#product-content-container .product-form-js').width();
        $stepContainer = $('.step-container:not(.attr-color)','.pdp-drawer');
        $stepContainer.each(function() {
            var $this = $(this);
            $this.find('.step-content').css( "width", containerWidth - $this.find('.step-header').outerWidth(true)-1); /*quickview*/
        });
    };

    self.initMobileCarouselViewer = function(){
        var $clonedAltViews = $('.product-img-js .views-js ul').clone();
        $clonedAltViews.addClass('mobile-viewer-js');
        $('.product-img-js .views-js').append($clonedAltViews);
    };

    self.updateProductDetailBtnURL = function(variationId){
        var $pdpBtn = $('.quickview-box-js .product-detail-btn-js'),
            pdpBtnURL = $pdpBtn.attr('href'),
            sizeOptionLabel = $('label.context-trigger-js.active-context-js');
        if(sizeOptionLabel.length>0){
            pdpBtnURL = sizeOptionLabel.attr("data-product-url");
        }
        pdpBtnURL = Utils.setURLParam(pdpBtnURL, 'variationId', variationId);
        $pdpBtn.attr('href', pdpBtnURL);
    };

    self.showAltViewControls = function(){
        if(screenSize.size() !== 'small') {
            $('.product-view-control-js').not('.secondary').show();
        }
    };

    return self;

}());

var viewDomAdd = ( function(){

    var self = {};

    self.decodeHTML = function(encodedText){
        var container = document.createElement("div");
        container.innerHTML = encodedText;
        return container.childNodes[0].nodeValue;
    };

    self.setupShareButton = function(){
        $shareButton = $("#share-button-container", "#pdp-header-content");
        $shareButton.clone().appendTo("#product-views-container");
    };

    self.appendZoomPopup = function(){
        var _$existingFullZoomPopup = $('.full-zoom-hopup-js'),
        _$fullZoomPopup = $('<div class="reveal-modal full-zoom-hopup-js">');
        // only append once
        if (_$existingFullZoomPopup.length === 0) {
            $('body').append(_$fullZoomPopup);
        }
    };

    self.createOlapicUploadWidget = function() {
        if (!WCS_CONFIG.get('PDP::olapicEnabled')) {
            return;
        }
        _olapicPartNumber = $('.product-form-js').attr('data-olapic-partnumber');

        if (_olapicPartNumber && OLAPIC_SETTINGS.SHOW_ALT_IMAGE === true) {
            var elementId = "olapic_upload_widget",
                customer_id = OLAPIC_SETTINGS.CUSTOMER_ID,
                upload_widget_config = OLAPIC_SETTINGS.UPLOAD_WIDGET_ID,
                tag_based = true,
                cat_based = false,
                collection = false,
                Olapic_ob = document.createElement("script"),
                canonicalUrl = "",
                url = canonicalUrl === "" ? document.domain+document.location.pathname : canonicalUrl;

            Olapic_ob.async = true;
            Olapic_ob.type = "text/javascript";
            Olapic_ob.src = encodeURI("//widgets.photorank.me/automator?e="+elementId+"&customer_id="+customer_id+"&url="+encodeURIComponent(url)+"&title="+encodeURIComponent(document.title)+"&widget="+upload_widget_config+"&tags="+_olapicPartNumber+"&tag_based="+tag_based+"&cat_based="+cat_based+"&collection="+collection);

            (document.getElementsByTagName("head")[0] || document.getElementsByTagName("body")[0]).appendChild(Olapic_ob);
        }
    };

    self.duplicateFullZoomBtn = function() {
        var $actionBtns     = $('.product-view-control-js').clone(true),
            _isSwatchPage   = pdpUpdatePage.setSwatchPage();

        $actionBtns.addClass('secondary');

        if (_isSwatchPage){
            $actionBtns.find('.btn-full').detach();
            $actionBtns.find('.btn-zoom span').removeClass('icon').addClass('graphic-icon-zoom-mobile');
        }
        else {
            $actionBtns.find('.btn-full-js').addClass('secondary');
            $actionBtns.find('.btn-zoom').detach();
        }

        $('div.product-img-js').append($actionBtns);
    };

    return self;

}());

var initGreenIndex = ( function(){

    var self = {};

    self.init = function(){
        if( ( $(".green-index-hopup-js").length < 1) || ( $(".green-index-hopup-js").attr("sku") === null) || ( $(".green-index-hopup-js").attr("sku") === ''))
        return;

        var sku         = $(".green-index-hopup-js").attr("sku"),
            request_url = "/greenindex/api/tbl_greenindex/search-sku/" + sku;

        self.ajax(request_url);
    };

    self.ajax = function(request_url){
            $.ajax ({
            url: request_url,
            dataType: "json",
            success: function(data){
                if(data !== null && data.result != 'failure'){
                    $(".greenshortdesc-js").html(data.product_name);
                    $(".greenscore-js").html(data.gi_score);
                    $(".greenclimimpact-js").html(data.climate_score);
                    $(".greenchemimpact-js").html(data.chemical_score);
                    $(".greenrescconsumption-js").html(data.resource_score);

                    $('#greenindex-area-js').removeClass('hide');
                }
            }
        });
    };

    return self.init;

}());

var powerReviewUtilities = ( function() {

    var self = {};

    var $topNav = $('.topnav-header');
    var $wybDisplay =  $('#pr-wyb-display'),
        $prContainer = $('#pr-container'),
        $prTabsContainer = $('.review-tabs-container'),
        $elementInView =  $wybDisplay.parent($prContainer),
        firstReviewsClick = true;

    self.init = function() {
        $(window).on( 'scroll', self.onWindowScroll);
        $(document).on( 'click', '.product-content-info-review-count-link, .product-content-info-rating, .pr-snippet-stars, .reviews-link, .star-rating-component', self.handleReviewsLinkClick );
        $(document).on( 'click', '.product-content-info-review-q-and-a-link-js', self.scrollToPRQA );
    };

    self.onWindowScroll = function (event) {
        if( $elementInView.find('.pr-wyb-header').hasClass('hide') && ($elementInView.find('.pr-carousel-slide').length) ){
            self.handlePowerReviewHeaderVisibility($elementInView);
        }
    };

    self.handleReviewsLinkClick = function (event) {
        var timeout;

        if (firstReviewsClick){
            timeout = 500;
        } else {
            timeout = 0;
        }

        event.preventDefault();

        if ( $('.pr-snapshot-no-ratings').is(':visible') || $('.pr-rd-no-reviews').is(':visible')){
            self.scrollToPRContainer();
            return;
        }

        if ( $('.pr-review-wrap, .pr-review').is(':visible')){
            $('.power-reviews-loading-indicator-js').removeClass('hide');
            setTimeout(function(){
                $('.power-reviews-loading-indicator-js').addClass('hide');
                self.scrollToPRContainer();
                firstReviewsClick = false;
            }, timeout);

        }
        else {
            $('.power-reviews-loading-indicator-js').removeClass('hide');
            setTimeout(function(){
                $('.power-reviews-loading-indicator-js').addClass('hide');
                self.scrollToPRContainer();
            }, 500);
        }
    };

    self.handlePowerReviewHeaderVisibility = function ($elementInView) {
        var elemTop          = $elementInView[ 0 ].getBoundingClientRect().top,
            elemBottom       = $elementInView[ 0 ].getBoundingClientRect().bottom;
        if((elemTop < window.innerHeight) && (elemBottom >= 0)){
                $elementInView.find('.pr-wyb-header').removeClass('hide');
        }
    };

    self.calculateOffsetWithStickyNav = function (offsetTop) {
        // If the brand has a sticky header subtract the topnav height. or return the original height
        if(!$topNav.hasClass('sticky')) {
            return offsetTop;
        }
        var topnavHeight = $topNav.outerHeight();

        // Add the minimized class to pick up any additional border before scrolling
        $topNav.addClass('sticky-minimized');
        var topnavBorder = parseInt($topNav.css('borderBottomWidth'), 10);

        return offsetTop - (topnavHeight + topnavBorder);
    };

    self.scrollToPRContainer = function () {
        var $prRatingReviews = $('#rating_reviews');
        var prScrollTop = $prRatingReviews.length > 0 ? $prRatingReviews.offset().top : $prContainer.offset().top;
        var isPowerReviewPopulated = $prRatingReviews.height() > 0;

        prScrollTop = self.calculateOffsetWithStickyNav(prScrollTop);

        $('html, body').animate({
            scrollTop: prScrollTop
        }, 800, function() {
            // Power review is only populate when component is in view
            //If Power Review is not populated yet. Continue to scroll to correct position
            var newPRScrollTop = self.calculateOffsetWithStickyNav($prRatingReviews.offset().top);
            if(!isPowerReviewPopulated && newPRScrollTop != prScrollTop) {
                $('html, body').animate({
                    scrollTop: newPRScrollTop
                }, 800);
            }
        });
    };

    self.scrollToPRQA = function () {
        var $prRatingQuestions = $('#rating_questions');
        if($prRatingQuestions.length == 0) {
            return;
        }
        var prScrollTop = self.calculateOffsetWithStickyNav($prRatingQuestions.offset().top);

        $('html, body').animate({
            scrollTop: prScrollTop
        }, 800);
    };

    return self.init;
}());

var pdpInitialSetup = ( function(){

    var self = {};

    self.init = function(){
        pdpUpdatePage.setSwatchPage();
        pdpTime.initCountDown();
        viewDomAdd.setupShareButton();
        initGreenIndex();
        viewDomAdd.appendZoomPopup();
        viewDomAdd.createOlapicUploadWidget();
        pdpUpdatePage.populateProductPartNumberAndAttrName();
        viewDomAdd.duplicateFullZoomBtn();
        pdpUpdatePage.setShowOverviewHandler();
        pdpUpdatePage.showAltViewControls();
        powerReviewUtilities();
        pdpUpdatePage.initDiscountTooltips();
    };

    return self.init;

}());

var quickViewInitialSetup = ( function(){

    var self = {};

    self.init = function(){
        pdpUpdatePage.initDiscountTooltips();
        pdpUpdatePage.setSwatchPage();
        pdpUpdatePage.setStepContentWidths();
        viewDomAdd.appendZoomPopup();
    };

    self.enableGridPageQuickview = function(isPdp) {
        if (WCS_CONFIG.get('quickView::quickViewAlternateViewsEnabled')) {
            isPdp = (isPdp || $('body').hasClass('grid'));
        }

        return isPdp;
    };


    return self.init;

}());

return {
    pdpInitialSetup : pdpInitialSetup,
    quickViewInitialSetup : quickViewInitialSetup,
    pdpUpdatePage : pdpUpdatePage,
    pdpTime : pdpTime,
    viewDomAdd : viewDomAdd,
    initGreenIndex : initGreenIndex,
    sizeChartSlideView : sizeChartSlideView,
    updateProductPartNumberAndAttrName : pdpUpdatePage.populateProductPartNumberAndAttrName
};

});
